(function () {
  function normalize(value) {
    return (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function escapeHtml(value) {
    return (value || '').replace(/[&<>"']/g, function (match) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[match];
    });
  }

  function haversineDistance(from, to) {
    function toRadians(value) {
      return (value * Math.PI) / 180;
    }

    var earthRadiusKm = 6371;
    var deltaLat = toRadians(to.lat - from.lat);
    var deltaLng = toRadians(to.lng - from.lng);
    var originLat = toRadians(from.lat);
    var targetLat = toRadians(to.lat);
    var a =
      Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
      Math.cos(originLat) * Math.cos(targetLat) * Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2);

    return earthRadiusKm * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
  }

  function formatDistance(distanceKm) {
    if (!Number.isFinite(distanceKm)) {
      return '';
    }

    if (distanceKm < 1) {
      return 'A ' + Math.round(distanceKm * 1000) + ' m de tu ubicacion';
    }

    return 'A ' + distanceKm.toFixed(1) + ' km de tu ubicacion';
  }

  function getStoreMarkerIcon() {
    return (
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M24 5.498a.47.47 0 0 0-.011-.055.436.436 0 0 0-.064-.192.47.47 0 0 0-.022-.048l-3.66-5a.5.5 0 0 0-.403-.205H4.16a.5.5 0 0 0-.403.205l-3.66 5a.47.47 0 0 0-.023.048.478.478 0 0 0-.043.095.481.481 0 0 0-.02.097.469.469 0 0 0-.011.055v2.13a3.351 3.351 0 0 0 1 2.374v13.496a.5.5 0 0 0 .5.5h21a.5.5 0 0 0 .5-.5V10.002a3.35 3.35 0 0 0 1-2.374ZM4.414.998h15.172l2.928 4H1.485ZM2.64 9.868a2.222 2.222 0 0 1-.815-.44A2.363 2.363 0 0 1 1 7.628v-1.63h4.75v1.63a2.37 2.37 0 0 1-.57 1.546 2.47 2.47 0 0 1-2.54.694Zm4.11-3.87h4.75v1.63a2.37 2.37 0 0 1-.57 1.546 2.464 2.464 0 0 1-3.61-.002 2.366 2.366 0 0 1-.57-1.544Zm5.75 0h4.75v1.63a2.37 2.37 0 0 1-.57 1.546 2.464 2.464 0 0 1-3.61-.002 2.366 2.366 0 0 1-.57-1.544Zm3.5 17H8v-8h8Zm6 0h-5v-8.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v8.5H2v-12.29c.035.016.072.024.107.038.082.033.166.06.25.086.085.025.168.05.254.068a3.396 3.396 0 0 0 .379.064l.09.008c.1.008.198.026.3.026a3.36 3.36 0 0 0 1.643-.445c.066-.036.128-.075.192-.115a3.286 3.286 0 0 0 .272-.189 3.095 3.095 0 0 0 .452-.425 3.353 3.353 0 0 0 .31-.425 3.38 3.38 0 0 0 5.75 0 3.38 3.38 0 0 0 5.75 0 3.352 3.352 0 0 0 .31.423 3.11 3.11 0 0 0 .452.426c.084.068.173.125.263.184.069.043.137.086.209.124a3.36 3.36 0 0 0 1.384.414c.023.002.045.006.068.007.065.004.128.02.195.02.093 0 .183-.016.275-.024l.105-.009a3.358 3.358 0 0 0 .38-.063c.082-.018.161-.042.242-.066.09-.028.178-.056.265-.091.034-.014.07-.02.103-.035Zm1-15.37a2.362 2.362 0 0 1-.826 1.801 2.46 2.46 0 0 1-3.355-.257 2.366 2.366 0 0 1-.57-1.544v-1.63H23Z"></path>' +
      '</svg>'
    );
  }

  function initStoreMap(section) {
    if (!section || section.dataset.initialized === 'true') {
      return;
    }

    section.dataset.initialized = 'true';

    var config = window.StoreMapConfig || {};
    var searchInputs = Array.prototype.slice.call(section.querySelectorAll('[data-store-search]'));
    var filterButtons = Array.prototype.slice.call(section.querySelectorAll('[data-store-filter]'));
    var actionButtons = Array.prototype.slice.call(section.querySelectorAll('[data-store-action]'));
    var cardsContainer = section.querySelector('[data-store-list]');
    var mapElement = section.querySelector('[data-store-map]');
    var loadingState = section.querySelector('[data-store-loading]');
    var fallbackState = section.querySelector('[data-store-fallback]');
    var emptyState = section.querySelector('[data-store-empty]');
    var statusElement = section.querySelector('[data-store-status]');
    var panel = section.querySelector('.store-map__panel');
    var stores = Array.prototype.slice.call(section.querySelectorAll('[data-store-card]')).map(function (card, index) {
      return {
        id: card.dataset.storeId,
        name: card.dataset.storeName,
        label: card.dataset.storeLabel,
        city: card.dataset.storeCity,
        district: card.dataset.storeDistrict,
        address: card.dataset.storeAddress,
        description: card.dataset.storeDescription,
        hours: card.dataset.storeHours,
        phone: card.dataset.storePhone,
        whatsapp: card.dataset.storeWhatsapp,
        directions: card.dataset.storeDirections,
        lat: Number(card.dataset.storeLat),
        lng: Number(card.dataset.storeLng),
        index: index,
        element: card,
        distanceElement: card.querySelector('[data-store-distance]'),
        nearestBadge: card.querySelector('[data-nearest-badge]'),
        marker: null,
        distanceKm: null,
      };
    });

    var map = null;
    var popup = null;
    var geolocateControl = null;
    var activeStoreId = null;
    var activeFilter = 'all';
    var userLocation = null;
    var pendingNearestLookup = false;

    function getSearchValue() {
      if (!searchInputs.length) {
        return '';
      }

      return searchInputs[0].value;
    }

    function syncSearchInputs(sourceInput) {
      searchInputs.forEach(function (input) {
        if (input !== sourceInput) {
          input.value = sourceInput.value;
        }
      });
    }

    function getVisibleStores() {
      return stores.filter(function (store) {
        return !store.element.hidden;
      });
    }

    function getMapPadding() {
      if (window.innerWidth >= 990) {
        return {
          top: 72,
          right: 72,
          bottom: 72,
          left: Math.min(panel.offsetWidth + 76, 520),
        };
      }

      var bottomPanelHeight = panel ? panel.offsetHeight : 0;

      return {
        top: 120,
        right: 16,
        bottom: bottomPanelHeight > 0 ? bottomPanelHeight + 20 : 300,
        left: 16,
      };
    }

    function updateStatus(message) {
      statusElement.textContent = message;
    }

    function resetNearestBadges() {
      stores.forEach(function (store) {
        store.nearestBadge.hidden = true;
      });
    }

    function setNearestBadge(visibleStores) {
      resetNearestBadges();

      if (!userLocation || !visibleStores.length) {
        return;
      }

      visibleStores[0].nearestBadge.hidden = false;
    }

    function updateDistanceBadges() {
      stores.forEach(function (store) {
        if (userLocation) {
          store.distanceKm = haversineDistance(userLocation, { lat: store.lat, lng: store.lng });
          store.distanceElement.hidden = false;
          store.distanceElement.textContent = formatDistance(store.distanceKm);
        } else {
          store.distanceKm = null;
          store.distanceElement.hidden = true;
          store.distanceElement.textContent = '';
        }
      });
    }

    function setUserLocation(location) {
      userLocation = location;
    }

    function sortStores(collection) {
      return collection.slice().sort(function (first, second) {
        if (Number.isFinite(first.distanceKm) && Number.isFinite(second.distanceKm)) {
          return first.distanceKm - second.distanceKm;
        }

        return first.index - second.index;
      });
    }

    function updateHash(storeId) {
      if (history.replaceState) {
        history.replaceState(null, '', window.location.pathname + window.location.search + '#' + storeId);
      } else {
        window.location.hash = storeId;
      }
    }

    function popupMarkup(store) {
      return (
        '<div class="store-map__popup">' +
        '<h3>' +
        escapeHtml(store.name) +
        '</h3>' +
        '<p>' +
        escapeHtml(store.description) +
        '</p>' +
        '<p>' +
        escapeHtml(store.address) +
        '</p>' +
        '<p>Horario: ' +
        escapeHtml(store.hours) +
        '</p>' +
        '<div class="store-map__popup-links">' +
        '<a href="' +
        store.directions +
        '" target="_blank" rel="noopener">Como llegar</a>' +
        '<a href="' +
        store.whatsapp +
        '" target="_blank" rel="noopener">WhatsApp</a>' +
        '</div>' +
        '</div>'
      );
    }

    function clearSelection() {
      activeStoreId = null;
      stores.forEach(function (store) {
        store.element.classList.remove('is-active');
        if (store.marker) {
          store.marker.getElement().classList.remove('is-active');
        }
      });

      if (popup) {
        popup.remove();
      }
    }

    function scrollCardIntoView(store) {
      store.element.scrollIntoView({
        block: 'nearest',
        inline: 'nearest',
        behavior: 'smooth',
      });
    }

    function focusMapOnStore(store, animate) {
      if (!map) {
        return;
      }

      map.easeTo({
        center: [store.lng, store.lat],
        zoom: Math.max(map.getZoom(), 13.8),
        padding: getMapPadding(),
        duration: animate === false ? 0 : 900,
        essential: true,
      });
    }

    function openPopupForStore(store) {
      if (!map || store.element.hidden) {
        return;
      }

      if (window.innerWidth < 990) {
        if (popup) {
          popup.remove();
        }
        return;
      }

      if (!popup) {
        popup = new mapboxgl.Popup({
          offset: 18,
          closeButton: false,
          closeOnClick: false,
          maxWidth: '320px',
        });
      }

      popup.setLngLat([store.lng, store.lat]).setHTML(popupMarkup(store)).addTo(map);
    }

    function selectStore(storeId, options) {
      options = options || {};

      var store = stores.find(function (entry) {
        return entry.id === storeId;
      });

      if (!store || store.element.hidden) {
        return;
      }

      activeStoreId = store.id;

      stores.forEach(function (entry) {
        var isActive = entry.id === store.id;
        entry.element.classList.toggle('is-active', isActive);
        if (entry.marker) {
          entry.marker.getElement().classList.toggle('is-active', isActive);
        }
      });

      if (options.scrollCard !== false) {
        scrollCardIntoView(store);
      }

      if (map) {
        if (options.panMap !== false) {
          focusMapOnStore(store, options.animate !== false);
        }

        if (options.openPopup !== false) {
          openPopupForStore(store);
        }
      }

      updateStatus('Seleccionada: ' + store.name + '. ' + getVisibleStores().length + ' tienda(s) visibles.');

      if (options.updateHash !== false) {
        updateHash(store.id);
      }
    }

    function fitMapToStores(collection, animate) {
      if (!map || collection.length === 0) {
        return;
      }

      if (collection.length === 1) {
        selectStore(collection[0].id, {
          animate: animate,
          scrollCard: false,
          openPopup: true,
        });
        return;
      }

      clearSelection();

      var bounds = new mapboxgl.LngLatBounds();
      collection.forEach(function (store) {
        bounds.extend([store.lng, store.lat]);
      });

      map.fitBounds(bounds, {
        padding: getMapPadding(),
        duration: animate === false ? 0 : 900,
        maxZoom: 11.6,
      });

      updateStatus(collection.length + ' tiendas visibles en el mapa.');
    }

    function fitMapToUserAndStore(store, animate) {
      if (!map || !userLocation) {
        return;
      }

      var bounds = new mapboxgl.LngLatBounds();
      bounds.extend([userLocation.lng, userLocation.lat]);
      bounds.extend([store.lng, store.lat]);

      map.fitBounds(bounds, {
        padding: getMapPadding(),
        duration: animate === false ? 0 : 900,
        maxZoom: 14.2,
      });
    }

    function syncMarkerVisibility() {
      stores.forEach(function (store) {
        if (store.marker) {
          store.marker.getElement().style.display = store.element.hidden ? 'none' : '';
        }
      });
    }

    function applyFilters(options) {
      options = options || {};
      var query = normalize(getSearchValue());

      stores.forEach(function (store) {
        var searchable = normalize([store.name, store.label, store.city, store.district, store.address].join(' '));
        var matchesCity = activeFilter === 'all' || store.city === activeFilter;
        var matchesQuery = query === '' || searchable.indexOf(query) !== -1;
        store.element.hidden = !(matchesCity && matchesQuery);
      });

      updateDistanceBadges();

      var visibleStores = sortStores(getVisibleStores());
      setNearestBadge(visibleStores);
      visibleStores.forEach(function (store) {
        cardsContainer.appendChild(store.element);
      });
      syncMarkerVisibility();

      if (visibleStores.length === 0) {
        clearSelection();
        emptyState.hidden = false;
        updateStatus('No encontramos tiendas con esos filtros.');
        return;
      }

      emptyState.hidden = true;

      if (activeStoreId && visibleStores.some(function (store) { return store.id === activeStoreId; })) {
        updateStatus(
          userLocation
            ? visibleStores.length + ' tiendas visibles. Ordenadas por cercania desde tu ubicacion.'
            : visibleStores.length + ' tiendas visibles.'
        );
        return;
      }

      if (visibleStores.length === 1) {
        selectStore(visibleStores[0].id, {
          animate: options.animateMap,
          scrollCard: false,
          openPopup: true,
          updateHash: false,
        });
        return;
      }

      fitMapToStores(visibleStores, options.animateMap !== false);
    }

    function setActiveFilter(filter) {
      activeFilter = filter;
      filterButtons.forEach(function (button) {
        var isActive = button.dataset.storeFilter === filter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function resetView() {
      searchInputs.forEach(function (input) {
        input.value = '';
      });
      setActiveFilter('all');
      clearSelection();
      updateDistanceBadges();
      applyFilters({ animateMap: false });

      if (history.replaceState) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }

      fitMapToStores(getVisibleStores(), true);
    }

    function findNearestStore() {
      if (!geolocateControl || typeof geolocateControl.trigger !== 'function') {
        updateStatus('No pudimos iniciar la geolocalizacion del mapa.');
        return;
      }

      pendingNearestLookup = true;
      updateStatus('Buscando la tienda mas cercana...');
      geolocateControl.trigger();
    }

    function showFallback(message) {
      loadingState.hidden = true;
      fallbackState.hidden = false;
      fallbackState.querySelector('p').textContent = message;
      updateStatus('El mapa interactivo no esta disponible.');
    }

    function createMarker(store) {
      var markerElement = document.createElement('button');
      markerElement.type = 'button';
      markerElement.className = 'store-map__marker';
      markerElement.setAttribute('aria-label', 'Ver ' + store.name + ' en el mapa');
      markerElement.innerHTML = getStoreMarkerIcon();
      markerElement.addEventListener('click', function () {
        selectStore(store.id, {
          animate: true,
          scrollCard: true,
          openPopup: true,
        });
      });

      store.marker = new mapboxgl.Marker({
        element: markerElement,
        anchor: 'center',
      })
        .setLngLat([store.lng, store.lat])
        .addTo(map);
    }

    function initMap() {
      if (!config.accessToken || !window.mapboxgl || typeof window.mapboxgl.Map !== 'function') {
        showFallback('Sigue usando la lista o abre cada tienda en Google Maps.');
        return;
      }

      if (window.mapboxgl.supported && !window.mapboxgl.supported()) {
        showFallback('Tu navegador no soporta la version interactiva del mapa.');
        return;
      }

      mapboxgl.accessToken = config.accessToken;

      map = new mapboxgl.Map({
        container: mapElement,
        style: config.style || 'mapbox://styles/mapbox/light-v11',
        center: [-77.03093038380794, -12.13173854128757],
        zoom: 10.2,
        cooperativeGestures: window.innerWidth >= 990,
        attributionControl: false,
      });

      map.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-right');
      map.addControl(new mapboxgl.FullscreenControl(), 'top-right');
      map.addControl(new mapboxgl.ScaleControl({ maxWidth: 100, unit: 'metric' }), 'bottom-right');
      map.addControl(new mapboxgl.AttributionControl({ compact: true }));
      geolocateControl = new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true,
          timeout: 10000,
        },
        followUserLocation: false,
        showUserHeading: false,
        trackUserLocation: true,
        showAccuracyCircle: false,
        showUserLocation: true,
      });

      geolocateControl.on('geolocate', function (event) {
        setUserLocation({
          lat: event.coords.latitude,
          lng: event.coords.longitude,
        });
        updateDistanceBadges();
        applyFilters({ animateMap: false });

        var nearestVisibleStore = sortStores(getVisibleStores())[0];

        if (pendingNearestLookup && nearestVisibleStore) {
          cardsContainer.prepend(nearestVisibleStore.element);
          selectStore(nearestVisibleStore.id, {
            animate: true,
            scrollCard: true,
            panMap: false,
            openPopup: true,
          });
          fitMapToUserAndStore(nearestVisibleStore, true);
          updateStatus('La tienda mas cercana es ' + nearestVisibleStore.name + '. Tu ubicacion aparece en marron.');
          pendingNearestLookup = false;
          return;
        }

        updateStatus('Ubicacion detectada.');
      });

      geolocateControl.on('error', function () {
        pendingNearestLookup = false;
        updateStatus('No pudimos acceder a tu ubicacion. Revisa permisos e intenta otra vez.');
      });

      map.addControl(geolocateControl, 'top-right');

      map.on('load', function () {
        stores.forEach(createMarker);
        loadingState.hidden = true;
        applyFilters({ animateMap: false });

        var hashStoreId = window.location.hash.replace('#', '').trim();
        var hashedStore = stores.find(function (store) {
          return store.id === hashStoreId;
        });

        if (hashedStore && !hashedStore.element.hidden) {
          selectStore(hashedStore.id, {
            animate: false,
            scrollCard: false,
            openPopup: true,
            updateHash: false,
          });
          return;
        }

        var initialStore = getVisibleStores()[0];

        if (initialStore) {
          selectStore(initialStore.id, {
            animate: false,
            scrollCard: false,
            openPopup: true,
            updateHash: false,
          });
        }
      });
    }

    cardsContainer.addEventListener('click', function (event) {
      var actionArea = event.target.closest('a, button');
      var card = event.target.closest('[data-store-card]');

      if (!card || (actionArea && !actionArea.hasAttribute('data-store-select'))) {
        return;
      }

      selectStore(card.dataset.storeId, {
        animate: true,
        scrollCard: false,
        openPopup: true,
      });
    });

    cardsContainer.addEventListener('keydown', function (event) {
      var card = event.target.closest('[data-store-card]');
      var interactiveElement = event.target.closest('a, button, input, select, textarea');

      if (!card || interactiveElement) {
        return;
      }

      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        selectStore(card.dataset.storeId, {
          animate: true,
          scrollCard: false,
          openPopup: true,
        });
      }
    });

    searchInputs.forEach(function (input) {
      input.addEventListener('input', function () {
        syncSearchInputs(input);
        applyFilters({ animateMap: false });
      });
    });

    filterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setActiveFilter(button.dataset.storeFilter);
        applyFilters();
      });
    });

    actionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var action = button.dataset.storeAction;

        if (action === 'nearest') {
          findNearestStore();
          return;
        }

        if (action === 'reset' || action === 'clear-search') {
          resetView();
        }
      });
    });

    window.addEventListener('resize', function () {
      if (!map) {
        return;
      }

      map.resize();

      if (activeStoreId) {
        var activeStore = stores.find(function (store) {
          return store.id === activeStoreId;
        });

        if (activeStore) {
          if (window.innerWidth < 990 && popup) {
            popup.remove();
          }
          focusMapOnStore(activeStore, false);
        }
      }
    });

    window.addEventListener('hashchange', function () {
      var hashStoreId = window.location.hash.replace('#', '').trim();
      var hashedStore = stores.find(function (store) {
        return store.id === hashStoreId;
      });

      if (hashedStore && !hashedStore.element.hidden) {
        selectStore(hashedStore.id, {
          animate: true,
          scrollCard: true,
          openPopup: true,
          updateHash: false,
        });
      }
    });

    initMap();
  }

  function bootStoreMaps() {
    var sections = document.querySelectorAll('.js-store-map-section');
    Array.prototype.forEach.call(sections, initStoreMap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootStoreMaps);
  } else {
    bootStoreMaps();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) {
      return;
    }

    if (event.target.classList && event.target.classList.contains('js-store-map-section')) {
      initStoreMap(event.target);
      return;
    }

    var nestedSection = event.target.querySelector('.js-store-map-section');
    if (nestedSection) {
      initStoreMap(nestedSection);
    }
  });
})();
